import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  trashIcon: {
    width: 26,
    height: 28,
    marginRight: 20,
  },
});
